import _ from 'underscore';

type RescheduleTargetModel = {
  id: number | string;
  belongsToGroup?: () => boolean;
  getLinkedPackageGroup?: () => { id: number | string } | null | undefined;
};

export type RescheduleTargetIds = {
  appointmentIds: (number | string)[];
  appointmentGroupIds: (number | string)[];
};

/**
 * Resolve the appointment/appointment-group ids that are about to be
 * rescheduled, for the reschedule-restrictions check.
 *
 * @param appointment The dragged/selected/edited appointment
 * @param relatedModels (optional) Other appointments being moved/saved alongside it
 */
export default function getRescheduleTargetIds(
  appointment: RescheduleTargetModel,
  relatedModels?: RescheduleTargetModel[],
): RescheduleTargetIds {
  if (relatedModels && relatedModels.length) {
    const appointmentIds: (number | string)[] = [];
    const appointmentGroupIds: (number | string)[] = [];

    relatedModels.forEach((item) => {
      const linkedGroup = item.getLinkedPackageGroup && item.getLinkedPackageGroup();

      if (linkedGroup) {
        appointmentGroupIds.push(linkedGroup.id);
      } else {
        appointmentIds.push(item.id);
      }
    });

    return {
      appointmentIds: _.uniq(appointmentIds),
      appointmentGroupIds: _.uniq(appointmentGroupIds),
    };
  }

  if (appointment.belongsToGroup && appointment.belongsToGroup()) {
    return {
      appointmentIds: [],
      appointmentGroupIds: [appointment.getLinkedPackageGroup!()!.id],
    };
  }

  return { appointmentIds: [appointment.id], appointmentGroupIds: [] };
}
